module.exports = __webpack_public_path__ + "static/media/wateringcan.73007774.png";